import { Components, Theme } from '@mui/material';
import { Spacing6, Spacing5, Spacing3 } from '../spacing';
import { Content, Backdrop } from '../color';
import { Corners } from '../corners/tokens';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  defaultProps: {
    fullWidth: true,
  },
  styleOverrides: {
    paperWidthXs: {
      maxWidth: 400,
    },
    paperWidthSm: {
      maxWidth: 600,
    },
    paperWidthMd: {
      maxWidth: 900,
    },
    paperWidthLg: {
      maxWidth: 1200,
    },
    paperWidthXl: {
      maxWidth: 1500,
    },
    paper: {
      boxSizing: 'border-box',
      borderRadius: Corners.extraLarge,
      padding: `${Spacing5} ${Spacing6}`,
      paddingBottom: Spacing6,
    },
    paperFullScreen: {
      borderRadius: 0,
    },
  },
};

export const MuiDialogTitle: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: {
      padding: 0,
      marginBlockEnd: Spacing3,
    },
  },
};

export const MuiDialogContent: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: {
      padding: 0,
      marginBlockEnd: Spacing3,
    },
    dividers: {
      paddingBlock: Spacing3,
      marginInline: `-${Spacing6}`,
      paddingInline: Spacing6,
    },
  },
};

export const MuiDialogContentText: Components<Theme>['MuiDialogContentText'] = {
  styleOverrides: {
    root: {
      color: Content.main,
    },
  },
};

export const MuiDialogActions: Components<Theme>['MuiDialogActions'] = {
  styleOverrides: {
    root: {
      padding: 0,
      paddingTop: Spacing3,
    },
  },
};

export const MuiBackdrop: Components<Theme>['MuiBackdrop'] = {
  styleOverrides: {
    root: {
      backgroundColor: Backdrop.main,
    },
  },
};
